PricingBI.vue<template>
	<v-row no-gutters>
		<v-col cols="12">
      <iframe
        title="BI Estoque Virtual X Divergências"
        style="height:80vh; width:100%"
        src="https://app.powerbi.com/view?r=eyJrIjoiOWViZWRmNjEtMzlkMi00OTk3LTg1ZDgtNzY1M2Y3NDQwZWNhIiwidCI6ImYxZGJlOWZhLWZkNTktNDMzZS04Y2RjLTI4ODRmZDgyYmRhNSJ9"
        frameborder="0"
        allowfullscreen="true"
      ></iframe>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "DivergenciasBI",
	components: {},
	data: () => ({
		tab: 0,
	}),
	computed: {},
	methods: {
		async init() {},
	},
	created() {
		this.init();
	},
};
</script>